<template>
  <div class="top">
    <div class="header">
      <v-img class="header-img" :src="headerImage" :aspect-ratio="xsOnly ? 0.8 : 1.8" />
    </div>

    <div class="download">
      <div class="download-container">
        <div v-if="!isScreenSmAndDown" class="download-donguri">
          <v-img :src="require('../assets/img/donguri@2x1.png')" widht="40%" />
        </div>
        <div class="download-sentence-area">
          <v-img class="download-sentence-title" :src="require('../assets/img/download_sp.png')" />
          <h4 class="download-sentence">
            このゲームは、一風変わったキャラクターを集めていく、<br />
            完全無料で遊べる放置ゲームだよ！ <br />
            登場するキャラクターはどれも個性的なものばかり… <br />
            図鑑のコンプリートを目指そう！ <br />
          </h4>
          <DownloadButtons />
        </div>
      </div>
      <div v-if="isScreenSmAndDown" class="download-sp-characters">
        <v-img class="download-sp-characters-1" :src="require('../assets/img/top_sp_chara/63.png')" />
        <v-img class="download-sp-characters-2" :src="require('../assets/img/top_sp_chara/donguri.png')" />
      </div>
    </div>

    <div class="shop">
      <p class="shop-sentence">＼公式グッズのオンラインショップがオープン！／</p>
      <div class="shop-button">
        <a href="https://okazukan.base.shop/" target="_blank">
          <v-img class="shop-img" :src="require('../assets/img/shop.png')" />
        </a>
      </div>
    </div>

    <div class="notice">
      <TitlePic imgSrc="notice_sp.png" />
      <div class="notice-container">
        <div class="notice-contents-list">
          <div v-for="data in getNoticeList" :key="data.id">
            <NoticeDetail :data="data" @clickSentence="clickNoticeSentence" />
          </div>
        </div>
        <Button text="もっと見る" @click="goToNoticeList()" />
        <NoticeCentence :selectedNotice="selectedNotice" @clickClose="closeNoticeCentence" />
        <div v-if="isScreenSmAndDown" class="notice-sp-characters">
          <v-img class="notice-sp-characters-1" :src="require('../assets/img/top_sp_chara/19.png')" />
          <v-img class="notice-sp-characters-2" :src="require('../assets/img/top_sp_chara/41.png')" />
        </div>
        <div v-else class="notice-pc-characters">
          <transition name="character-right">
            <v-img
              v-show="isShowNoticePcCharacters1"
              class="notice-pc-characters-1"
              :src="require('../assets/img/top_sp_chara/62.png')"
            />
          </transition>
          <transition name="character-left">
            <v-img
              v-show="isShowNoticePcCharacters2"
              class="notice-pc-characters-2"
              :src="require('../assets/img/top_sp_chara/1.png')"
            />
          </transition>
        </div>
      </div>
    </div>

    <div class="play">
      <div class="play-container">
        <v-img class="play-room" v-if="!isScreenSmAndDown" :src="require('../assets/img/IMG_3492@2x.png')" />
        <div class="play-contents">
          <TitlePic class="play-pic" imgSrc="play_sp.png" />
          <h4 class="play-sentence">
            料理を並べてトモダチを集めよう！<br />
            トモダチからスプーンをもらって<br />
            家具や料理と交換しよう！<br />
          </h4>
          <div class="play-button">
            <Button text="詳しく見る" @click="goToHowToPlay()" />
          </div>
        </div>
        <div v-if="isScreenSmAndDown" class="play-sp-characters">
          <v-img class="play-sp-characters-1" :src="require('../assets/img/top_sp_chara/1.png')" />
          <v-img class="play-sp-characters-2" :src="require('../assets/img/top_sp_chara/6.png')" />
        </div>
        <div v-else class="play-pc-characters">
          <transition name="character-right">
            <v-img
              v-show="isShowPlayPcCharacters1"
              class="play-pc-characters-1"
              :src="require('../assets/img/top_sp_chara/18.png')"
            />
          </transition>
          <transition name="character-left">
            <v-img
              v-show="isShowPlayPcCharacters2"
              class="play-pc-characters-2"
              :src="require('../assets/img/top_sp_chara/16.png')"
            />
          </transition>
        </div>
      </div>
    </div>

    <div class="gallery">
      <div class="gallery-pic">
        <TitlePic imgSrc="gallery_sp.png" />
      </div>
      <div class="gallery-container">
        <div class="gallery-left">
          <div>
            <h4 class="gallery-sentence">
              個性豊かなトモダチの<br />
              楽しくて愉快な日常を<br />
              のぞいてみよう！<br />
            </h4>
            <Button class="gallery-button" text="もっと見る" @click="goToGalleryList" />
          </div>
        </div>
        <div class="gallery-right">
          <v-img :src="require('../assets/img/gallerypic_sp.png')" />
        </div>
        <div v-if="!isScreenSmAndDown" class="gallery-pc-characters">
          <transition name="character-left">
            <v-img
              v-show="isShowGalleryPcCharacters1"
              class="gallery-pc-characters-1"
              :src="require('../assets/img/top_sp_chara/13.png')"
            />
          </transition>
        </div>
      </div>
    </div>

    <div class="twitter">
      <TitlePic class="twitter-pic" imgSrc="twitter_sp.png" />
      <div class="twitter-container">
        <!-- <div class="twitter-timeline">
          <a class="twitter-timeline" :data-height="xsOnly ? '300px' : '650px'" :href="timeLineUrl" data-lang="ja"></a>
          <div class="twitter-widgets" is="script" async :src="widgetsSrc"></div>
        </div> -->
        <div class="timeline">
          <a
            class="twitter-timeline"
            data-height="550px"
            :href="'https://twitter.com/okazukan_info?ref_src=twsrc%5Etfw'"
            data-lang="ja"
          ></a>
          <div class="twitter-widgets" is="script" async :src="'https://platform.twitter.com/widgets.js'"></div>
        </div>
        <div v-if="isScreenSmAndDown" class="twitter-sp-characters">
          <v-img class="twitter-sp-characters-1" :src="require('../assets/img/top_sp_chara/29.png')" />
          <v-img class="twitter-sp-characters-2" :src="require('../assets/img/top_sp_chara/18.png')" />
          <v-img class="twitter-sp-characters-3" :src="require('../assets/img/top_sp_chara/62.png')" />
        </div>
        <div v-else class="twitter-pc-characters">
          <transition name="character-left">
            <v-img
              v-show="isShowTwitterPcCharacters1"
              class="twitter-pc-characters-1"
              :src="require('../assets/img/top_sp_chara/34.png')"
            />
          </transition>
          <transition name="character-right">
            <v-img
              v-show="isShowTwitterPcCharacters2"
              class="twitter-pc-characters-2"
              :src="require('../assets/img/top_sp_chara/29_2.png')"
            />
          </transition>
          <transition name="character-left">
            <v-img
              v-show="isShowTwitterPcCharacters3"
              class="twitter-pc-characters-3"
              :src="require('../assets/img/top_sp_chara/14.png')"
            />
          </transition>
        </div>
      </div>
    </div>

    <div class="youtube">
      <div class="youtube-contents">
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/XpxJkbav3Hk?controls=0"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DownloadButtons from '@/components//DownloadButtons.vue';
import NoticeDetail from '@/components/NoticeDetail';
import NoticeCentence from '@/components/NoticeSentence.vue';
import TitlePic from '@/parts/TitlePic.vue';
import Button from '@/parts/Button';

export default {
  name: 'Top',
  components: {
    DownloadButtons,
    NoticeDetail,
    NoticeCentence,
    TitlePic,
    Button
  },
  data() {
    return {
      timeLineUrl: 'https://twitter.com/okazukan_info?ref_src=twsrc%5Etfw',
      widgetsSrc: 'https://platform.twitter.com/widgets.js',
      detailTitle: '',
      detailText: '',
      selectedNotice: null,
      // アニメーション用
      scrollY: 0,
      isShowNoticePcCharacters1: false,
      isShowNoticePcCharacters2: false,
      isShowPlayPcCharacters1: false,
      isShowPlayPcCharacters2: false,
      isShowGalleryPcCharacters1: false,
      isShowTwitterPcCharacters1: false,
      isShowTwitterPcCharacters2: false,
      isShowTwitterPcCharacters3: false
    };
  },
  props: {
    isShowLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('notice', ['noticeList']),
    isScreenSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    headerImage() {
      return this.xsOnly ? require('../assets/img/header_sp.png') : require('../assets/img/header_pc.png');
    },
    getNoticeList() {
      if (this.isScreenSmAndDown) {
        return this.noticeList.slice(0, 2);
      } else {
        return this.noticeList.slice(0, 3);
      }
    }
  },
  mounted() {
    document.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY;
      if (this.scrollY > 550) {
        setInterval(() => {
          this.isShowNoticePcCharacters1 = true;
        }, 200);
      }
      if (this.scrollY > 900) {
        setInterval(() => {
          this.isShowNoticePcCharacters2 = true;
        }, 200);
      }
      if (this.scrollY > 1150) {
        setInterval(() => {
          this.isShowPlayPcCharacters1 = true;
        }, 200);
      }
      if (this.scrollY > 1450) {
        setInterval(() => {
          this.isShowPlayPcCharacters2 = true;
        }, 200);
      }
      if (this.scrollY > 1800) {
        setInterval(() => {
          this.isShowGalleryPcCharacters1 = true;
        }, 200);
      }
      if (this.scrollY > 2150) {
        setInterval(() => {
          this.isShowTwitterPcCharacters1 = true;
        }, 200);
      }
      if (this.scrollY > 2500) {
        setInterval(() => {
          this.isShowTwitterPcCharacters2 = true;
        }, 200);
      }
      if (this.scrollY > 2900) {
        setInterval(() => {
          this.isShowTwitterPcCharacters3 = true;
        }, 200);
      }
    },
    goToNoticeList() {
      this.$router.push('notice-list');
    },
    goToHowToPlay() {
      this.$router.push('/how-to-play');
    },
    goToGalleryList() {
      this.$router.push('/gallery-list');
    },
    clickNoticeSentence(data) {
      this.selectedNotice = data;
    },
    closeNoticeCentence() {
      this.selectedNotice = null;
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
.top {
  overflow-x: hidden;
}

.header {
  background-color: #fef5e2;

  &-img {
    max-width: 1410px;
    margin: 0 auto;
  }
}

.download {
  background-color: #ffd295;
  width: 100%;
  position: relative;

  @media screen and (min-width: 960px) {
    padding: 10px;
  }

  &-container {
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 1410px;
    margin: 0 auto;
  }

  &-donguri {
    width: 45%;
    display: block;
    padding: 0px 10%;
    background: url('../assets/img/63_@2x.png') no-repeat, url('../assets/img/19@2x.png') no-repeat,
      url('../assets/img/6_@2x.png') no-repeat, url('../assets/img/41@2x.png') no-repeat;
    background-size: 30%;
    background-position: left 12% top -10%, left 10% top 80%, left 83% top 15%, left 90% top 100%;
  }

  &-sentence-area {
    width: 100%;
    max-width: 500px;

    @media screen and (min-width: 960px) {
      width: 55%;
    }
  }

  &-sentence {
    text-align: center;
    padding: 16px 0;
    color: #707070;
    line-height: 2;

    @media screen and (max-width: 460px) {
      font-size: 0.8em;
    }

    @media screen and (min-width: 960px) {
      font-size: 1.2em;
    }
  }
}

.shop {
  background-color: #ffd295;
  width: 100%;
  position: relative;
  padding-bottom: 20px;

  &-button {
    width: 50%;
    // background-color: white;
    background-image: url('../assets/img/shop_back.png');
    background-size: cover;
    position: relative;
    margin: 0 auto;
    outline: 3px solid #fce8a8;
    /*アニメーションの指定*/
    transition: all 0.3s;
  }
  &-button :hover {
    box-shadow: 0 7px 10px rgba(0, 0, 0, 0.3);
    border-color: transparent;
  }

  &-sentence {
    text-align: center;
    color: #707070;
    line-height: 2;
    font-size: 1.2em;
    font-weight: bold;

    @media screen and (max-width: 460px) {
      font-size: 0.5em;
    }
  }
}

.notice {
  background-color: #fce8a8;
  padding: 20px;
  position: relative;

  @media screen and (min-width: 960px) {
    padding: 60px;
  }

  &-container {
    position: relative;
    max-width: 1000px;
    margin: 0 auto;
  }
}

.play {
  background-color: #ffd295;
  padding: 20px;
  position: relative;

  @media screen and (min-width: 960px) {
    min-height: 400px;
    padding: 60px;
  }

  &-container {
    @media screen and (min-width: 960px) {
      display: flex;
      gap: 40px;
      justify-content: center;
      max-width: 1000px;
      margin: 0 auto;
      position: relative;
    }
  }

  &-room {
    width: 240px;
    max-width: 240px;
  }

  &-contents {
    position: relative;
  }

  &-pic {
    @media screen and (min-width: 960px) {
      min-width: 320px;
    }
  }

  &-sentence {
    text-align: center;
    padding: 16px 0;
    color: #707070;
    line-height: 2;

    @media screen and (max-width: 460px) {
      font-size: 0.8em;
    }

    @media screen and (min-width: 960px) {
      position: absolute;
      top: 0;
      left: 0;
      width: 320px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.2em;
    }
  }

  &-button {
    @media screen and (min-width: 960px) {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 20px auto;
    }
  }
}

.gallery {
  background-color: #fce8a8;
  margin: 0 auto;
  overflow: hidden;

  &-pic {
    padding: 20px;

    @media screen and (min-width: 960px) {
      padding: 60px 20px 20px 20px;
      position: absolute;
      width: 100vw;
      margin-left: -200px;
    }
  }

  &-container {
    display: flex;
    justify-content: center;

    @media screen and (min-width: 960px) {
      position: relative;
      max-width: 1000px;
      margin: 0 auto;
    }
  }

  &-left {
    width: 42%;
    max-width: 400px;
    position: relative;
    padding: 40px 8px;
    max-height: 550px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
  }

  &-sentence {
    text-align: center;
    color: #707070;
    line-height: 2;
    white-space: nowrap;
    margin-bottom: 10px;

    @media screen and (max-width: 460px) {
      font-size: 0.8em;
    }

    @media screen and (min-width: 960px) {
      font-size: 1.2em;
      margin-top: 100px;
      margin-bottom: 40px;
    }
  }

  &-button {
    width: 90%;
    max-width: 200px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }

  &-right {
    width: 48%;
    margin-right: -5%;
    margin-bottom: -5%;
    max-width: 550px;

    @media screen and (min-width: 960px) {
      margin-top: 100px;
      max-width: 400px;
    }
  }
}

.twitter {
  background-color: #ffd295;
  padding: 20px;
  position: relative;

  @media screen and (min-width: 960px) {
    padding: 60px;
  }

  &-pic {
    margin-top: 4px;
    margin-bottom: 20px;
  }

  &-container {
    @media screen and (min-width: 960px) {
      position: relative;
      max-width: 1000px;
      margin: 0 auto;
    }
  }

  &-timeline {
    max-width: 1000px;
    margin: 0 auto;

    @media screen and (min-width: 960px) {
      margin-bottom: 100px;
    }
  }
}

.youtube {
  background-color: #fce8a8;
  padding: 60px 20px 20px 20px;

  @media screen and (min-width: 960px) {
    padding: 60px;
  }

  &-contents {
    aspect-ratio: 16 / 9;
    max-width: 1000px;
    margin: 0 auto;

    @media screen and (min-width: 960px) {
      margin-top: 50px;
    }
  }
}

.download-sp-characters {
  &-1 {
    position: absolute;
    top: 80%;
    left: -8%;
    width: 36%;
    max-width: 220px;
    z-index: 100;
  }
  &-2 {
    position: absolute;
    top: 85%;
    right: -8%;
    width: 31%;
    max-width: 210px;
    z-index: 100;
  }
}

.notice-sp-characters {
  &-1 {
    position: absolute;
    top: 70%;
    left: -10%;
    width: 36%;
    max-width: 220px;
    z-index: 100;
  }
  &-2 {
    position: absolute;
    top: 72%;
    right: -10%;
    width: 40%;
    max-width: 220px;
    z-index: 100;
  }
}

.play-sp-characters {
  &-1 {
    position: absolute;
    top: 80%;
    left: -8%;
    width: 36%;
    max-width: 220px;
    z-index: 100;
  }
  &-2 {
    position: absolute;
    top: 72%;
    right: -8%;
    width: 38%;
    max-width: 220px;
    z-index: 100;
  }
}

.twitter-sp-characters {
  &-1 {
    position: absolute;
    top: -16%;
    left: -10%;
    width: 36%;
    max-width: 220px;
    z-index: 100;
  }
  &-2 {
    position: absolute;
    top: -12%;
    right: -10%;
    width: 38%;
    max-width: 220px;
    z-index: 100;
  }
  &-3 {
    position: absolute;
    top: 86%;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 38%;
    max-width: 160px;
    z-index: 100;
  }
}

.notice-pc-characters {
  &-1 {
    position: absolute;
    top: -80%;
    right: -180px;
    width: 70%;
    max-width: 350px;
    z-index: 100;
  }
  &-2 {
    position: absolute;
    top: 60%;
    left: -100px;
    width: 70%;
    max-width: 320px;
    z-index: 100;
  }
}

.play-pc-characters {
  &-1 {
    position: absolute;
    top: -10%;
    right: -200px;
    width: 70%;
    max-width: 350px;
    z-index: 100;
    @media screen and (min-width: 1100px) {
      right: -150px;
    }
  }
  &-2 {
    position: absolute;
    top: 65%;
    right: -20px;
    width: 70%;
    max-width: 320px;
    z-index: 100;
    @media screen and (min-width: 1100px) {
      right: 0;
    }
  }
}

.gallery-pc-characters {
  &-1 {
    position: absolute;
    top: 30%;
    left: -10%;
    width: 320px;
    z-index: 100;
  }
}

.twitter-pc-characters {
  &-1 {
    position: absolute;
    top: -20%;
    left: -25%;
    width: 320px;
    z-index: 100;
  }
  &-2 {
    position: absolute;
    top: 40%;
    right: -25%;
    width: 320px;
    z-index: 100;
  }
  &-3 {
    position: absolute;
    top: 90%;
    left: 40%;
    width: 320px;
    z-index: 100;
  }
}

.character-right-enter-active {
  transition: all 0.8s ease;
}
.character-right-enter {
  transform: translateX(50px);
  opacity: 0;
}
.character-left-enter-active {
  transition: all 0.8s ease;
}
.character-left-enter {
  transform: translateX(-50px);
  opacity: 0;
}
</style>
